/* eslint-disable no-return-assign */

/* eslint-disable no-param-reassign */

/* eslint-disable consistent-return */
import produce from 'immer';
import { getNextGridSizesDuringPan, determineSizeUponToggle } from "../resize-helpers"; // rubber banding resistance when dragging extends beyond resizable max
// min widths of columns or rows.

var BANDING_RESISTANCE = 0.06;
/**
 * Dimension reducer
 *
 * Update state for either columns or rows.
 */

export function dimensionReducer(state, action) {
  return produce(state, function (draft) {
    switch (action.type) {
      case 'COMMIT':
        {
          updateTemplate(draft);
          break;
        }

      case 'COMMIT_ALL':
        {
          updateTemplate(draft);
          break;
        }

      case 'UPDATE':
        getInitialDimensionState(state, action.payload.template[state.breakpoint][state.type]);
        break;

      case 'UPDATE_CONTAINER_SIZE':
        determineSizeUponToggle(draft.units, action.payload[state.type === 'columns' ? 'width' : 'height']);
        break;

      case 'SNAPSHOT':
      case 'PAN_START':
        draft.units.forEach(function (unit, i) {
          unit.snapshot = action.payload.snapshot[i];
          unit.size = action.payload.snapshot[i];
        });
        break;

      case 'PAN':
        draft.offset.set(getNextGridSizesDuringPan(action.payload.index, action.payload.pan, draft) * BANDING_RESISTANCE);
        break;

      case 'PAN_END':
        draft.offset.set(0);
        updateTemplate(draft);
        break;

      case 'TOGGLE_SHOWING':
        draft.units[action.payload.index].isShowing = action.payload.isShowing;
        updateTemplate(draft);
        break;

      default:
        return state;
    }
  });
}
/**
 * Determine the initial state of a dimension.
 */

function getInitialDimensionState(draft, units) {
  draft.units = units.map(function (unit, i) {
    var _draft$units$i, _existingUnit$snapsho;

    var existingUnit = (_draft$units$i = draft.units[i]) !== null && _draft$units$i !== void 0 ? _draft$units$i : {};

    var getSize = function getSize() {
      if (unit.showing === false) {
        return 0;
      } // this is borking things. need to investigate.


      var firstSize = typeof unit.defaultSize === 'string' ? null : unit.defaultSize;

      if (existingUnit.lastSize) {
        return existingUnit.lastSize;
      }

      return existingUnit.size ? existingUnit.size : firstSize;
    };

    var size = getSize();
    var nextState = {
      isFlex: unit.defaultSize === '1fr',
      min: unit.defaultMin || 30,
      max: unit.defaultMax,
      lastSize: !unit.showing ? existingUnit.size : undefined,
      size: size,
      snapshot: (_existingUnit$snapsho = existingUnit.snapshot) !== null && _existingUnit$snapsho !== void 0 ? _existingUnit$snapsho : null,
      isShowing: unit.showing !== false,
      scale: 1,
      offset: 0
    };
    return nextState;
  });
}

function updateTemplate(draft) {
  draft.template.set(getUnitsGridString(draft));
}
/**
 * Get the combined panel string for use in
 * grid-template-columns, or grid-template-rows.
 */


function getUnitsGridString(draft) {
  var hasFlex = false;
  return draft.units.map(function (unit) {
    var nextState = getUnitGridString(unit, hasFlex);

    if (unit.isFlex && unit.size && unit.isShowing) {
      hasFlex = true;
    }

    return nextState;
  }).join(' ');
}
/**
 * Given an individual panel, determine its grid string
 * for use in grid-template-columns or grid-template-rows. This
 * also
 */


function getUnitGridString(panel) {
  var live = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var getMax = function getMax() {
    if (panel.isFlex && !live) {
      return '1fr';
    }

    var sizeUnit = typeof panel.size === 'string' ? '' : 'px';
    var maxUnit = typeof panel.max === 'string' ? '' : 'px';

    if (panel.max) {
      return "min(".concat(panel.size).concat(sizeUnit, ", ").concat(panel.max).concat(maxUnit, ")");
    }

    return "".concat(panel.size).concat(sizeUnit);
  };

  var paneSize = panel.isShowing ? // eslint-disable-next-line
  "minmax(".concat(panel.min, "px, ").concat(getMax(), ")") : "0px";
  return "".concat(paneSize);
}